export default __webpack_public_path__ + "static/media/symptomicon.479904b7.png";